export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="marquee py-16 md:py-24 border-y border-ink/15">
      <div className="marquee__track">
        {doubled.map((it, i) => (
          <div key={i} className="flex items-center gap-16 shrink-0">
            <span className="font-serif-display text-[9vw] md:text-[6vw] leading-none whitespace-nowrap">
              {it}
            </span>
            <span className="text-plum text-[6vw] md:text-[3vw]">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
